export default __webpack_public_path__ + "static/media/G0140.34I-26068_-15990_0.1666257060000.600513c3.jpg";